import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import dayjs from "dayjs";
import { useMediaQuery } from "react-responsive";
// eslint-disable-next-line import/no-cycle
import { CardsContainerGrid } from "../CardsContainer";
// eslint-disable-next-line import/no-cycle
import { FlightCard } from "../Card";
// eslint-disable-next-line import/no-cycle
import { HotelCard } from "../Cards/Hotel";
// eslint-disable-next-line import/no-cycle
import { Tabs, Tab } from "../TabsAndAccordions";
import {
	LOCAL_EN,
	LOCAL_FR,
	AD_MODULE_OFFER_TYPE_RETURN_FLIGHT,
	AD_MODULE_OFFER_TYPE_PACKAGE,
	AD_MODULE_OFFER_TYPE_ONE_WAY_FLIGHT,
	LOCAL_STORAGE_KEY_PREFERRED_GATEWAY,
	DEFAULT_GATEWAY_EN,
	DEFAULT_GATEWAY_FR,
} from "../../const/const";
import { defaultOrderingTabData } from "./Filters/util";
import { RCL, RCL as useTranslation } from "../RCL";
import "dayjs/locale/fr";
import { PageContext } from "../PageContext";
import { useUser } from "../../context";
import { addSEOSupportToURL } from "../../utils/gatsby-helpers";
import { Icon } from "../Icons/Icons";
import { cloudinaryImageAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
// eslint-disable-next-line import/no-cycle
import { Filters } from "./Filters/Filters";
// eslint-disable-next-line import/no-cycle
import { NoResultsCards } from "./NoResultsCards/NoResultsCards";
// eslint-disable-next-line import/no-cycle
import { CollapsibleLinksList } from "../../sharedComponents/CollapsibleLinksList";
import { setBookingSearchBox } from "../Header/BookingSearchBox/BookingSearchBox";
import gatewaysGroup from "../Header/Gateway/Menu/HeaderGateways.mock.json";
import * as styles from "./HotelCardTabs.module.scss";

const RenderCards = ({ offers, locale, renderLink, isMobile, gatewayListUI }) => {
	const { affiliate } = useUser();
	const loadAllLabel = useTranslation({ searchKey: "load-all" });
	const loadMoreLabel = useTranslation({ searchKey: "load-more" });
	const [aliasCode, setAliasCode] = useState("btd");
	const isPackagesOfferType = offers.every(
		offer => offer.OfferType === AD_MODULE_OFFER_TYPE_PACKAGE
	);

	const [matchingOffers, setMatchingOffers] = useState(defaultOrderingTabData(offers, locale));

	useEffect(() => {
		if (affiliate?.code) {
			setAliasCode(affiliate.code);
		}
	}, [affiliate]);

	useEffect(() => {
		const validOffers = offers.filter(offer =>
			dayjs(offer.DepartureDate).isAfter(dayjs().startOf("day"))
		);
		setMatchingOffers(defaultOrderingTabData(validOffers, locale));
	}, [offers, locale]);

	return (
		<>
			{(offers.length > 6 || isMobile) && (
				<Filters
					tabOffers={offers}
					locale={locale}
					setMatchingOffers={setMatchingOffers}
					isMobile={isMobile}
					gatewayListUI={gatewayListUI}
					offerType={isPackagesOfferType ? "packages" : "flights"}
				/>
			)}
			<div id="travel-deals">
				{matchingOffers?.[0]?.OfferType === AD_MODULE_OFFER_TYPE_RETURN_FLIGHT && (
					<div className={styles.flightsMessage}>
						<RCL searchKey="take-off-on-your-next-vacation-with-sunwing-airlines-as-one-of-the-leading" />
					</div>
				)}
				<CardsContainerGrid
					key={matchingOffers}
					numberToShow={6}
					moreToShow={6}
					labels={{
						loadAll: loadAllLabel,
						loadMore: loadMoreLabel,
					}}>
					{matchingOffers?.map((i, index) => {
						if (!i) {
							return <></>;
						}
						const dayOfWeek = dayjs(i.DepartureDate, "YYYY-MM-D").format("ddd");
						const date = dayjs(i.DepartureDate, "YYYY-MM-D").format("MMM D, YYYY");
						const Duration = i.Duration ? `${i.Duration} ${RCL({ searchKey: "days" })}` : "";
						const deepLink =
							i.DeepLink.search(/([&|?]alias=)(\w{3})/i) > 0
								? i.DeepLink.replace(/([&|?]alias=)(\w{3})/i, `$1${aliasCode}`)
								: i.DeepLink.concat(`&alias=${aliasCode}`);

						if (i.OfferType === AD_MODULE_OFFER_TYPE_PACKAGE) {
							return (
								<HotelCard
									// eslint-disable-next-line react/no-array-index-key
									key={`${i.AccommodationInfo?.AccommodationCode}-${index}`}
									image={{
										...cloudinaryImageAdapter({
											cloudinaryImage: {
												width: 1024,
												height: 576,
												public_id: `sunwing-prod/HotelImages/${i.AccommodationInfo?.AccommodationCode}/16x9/001`,
											},
											maxWidth: 400,
											title: i.hotelName,
											desc: i.hotelName,
										}),
									}}
									header={`${i.Destination.Name}, ${i.Destination.CountryName}`}
									headingAs="h3"
									headingSize="h5"
									link={{
										to: deepLink,
										target: "_self",
										text: i.AccommodationInfo.AccommodationName,
									}}
									renderLink={renderLink}
									subheader={i.AccommodationInfo.AccommodationName}
									stars={parseFloat(i.AccommodationInfo.StarRating)}
									days={i.Duration ? `${i.Duration} ${RCL({ searchKey: "days" })}` : ""}
									price={i.Price}
									wasPrice={i.RegPrice}
									save={i.SaveUpto && `${RCL({ searchKey: "save-up-to" })} ${i.SaveUpto}%`}
									local={locale}
									clickable={true}
									ratio="4/3"
									labels={{
										allInc: i.MealPlan,
										was: RCL({ searchKey: "was" }),
										perAdult: RCL({ searchKey: "per-adult" }),
										taxAndFee: i.tax,
										departureDate: date,
									}}
								/>
							);
						}
						return (
							<FlightCard
								// eslint-disable-next-line react/no-array-index-key
								key={`${i.OfferType}-${index}`}
								link={{
									to: deepLink,
									target: "_blank",
									text: i.Destination?.Name,
								}}
								header={i.Destination?.Name}
								days={
									i.OfferType === AD_MODULE_OFFER_TYPE_ONE_WAY_FLIGHT
										? RCL({ searchKey: "one-way" })
										: Duration
								}
								price={i.Price}
								local={locale}
								labels={{
									from: i.Gateway.Name,
									dayOfWeek,
									departureDate: date,
									taxAndFee: i.tax,
								}}
							/>
						);
					})}
				</CardsContainerGrid>
			</div>
			{matchingOffers?.length === 0 ? (
				<>
					<span className={styles.noResults}>
						<RCL searchKey="were-so-sorry-no-results-available" />
					</span>
					<span className={styles.noResultsSub}>
						<RCL searchKey="we-couldnt-find-exactly-what-you-were-looking-for-but-you-may-also-like" />
					</span>
					<NoResultsCards locale={locale} offerType={isPackagesOfferType ? "Package" : "Flight"} />
				</>
			) : (
				<p className={styles.disclaimer}>{RCL({ searchKey: "ad-module-disclaimer" })}</p>
			)}
		</>
	);
};

const HotelCardTabs = ({ data, locale, renderLink }) => {
	const pageContext = useContext(PageContext);

	const getDefaultGateway = useCallback(() => {
		let code = pageContext.locale === LOCAL_EN ? DEFAULT_GATEWAY_EN : DEFAULT_GATEWAY_FR;
		if (pageContext?.gateway?.Code) {
			code = pageContext?.gateway?.Code;

			// Set default gateway (temporary) in the booking search box based on the specific ad module page
			setBookingSearchBox(
				{
					from: pageContext.gateway.Code,
					force: true,
				},
				1000
			);
		}

		const _gateway = data.find(i => i?.Gateway?.Code === code);
		if (_gateway) {
			return _gateway.Gateway;
		}
		return data?.[0].Gateway;
	}, [pageContext, data]);

	const [defaultGateway, setDefaultGateway] = useState(getDefaultGateway());

	const gateways = useMemo(
		() => {
			const mockGateways = gatewaysGroup.reduce((acc, item) => [...acc, ...item.gateways], []);
			return data
				?.filter(m => m)
				.map(m => {
					const mockGateway = mockGateways.find(gateway => gateway.value === m.Gateway.Code);
					const gateway = { ...m.Gateway };
					if (mockGateway) gateway.Name = mockGateway.label;
					return gateway;
				})
				.filter(m => m)
				.filter(m => m.Code !== defaultGateway.Code);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[data, defaultGateway.Code]
	); // defalultGatewayCode change after loading from local storage doesn't fire this hook if we just use defaultGatewayCode

	const [tabsData, setTabsData] = useState(
		data.find(i => i?.Gateway?.Code === defaultGateway.Code)
	);

	useEffect(() => {
		try {
			if (pageContext?.gateway?.Code !== defaultGateway.Code) {
				const localStorageGatewayCode = JSON.parse(
					localStorage.getItem(LOCAL_STORAGE_KEY_PREFERRED_GATEWAY)
				);
				if (localStorageGatewayCode?.value) {
					const _gateway = data.find(i => i?.Gateway?.Code === localStorageGatewayCode?.value);
					if (_gateway) {
						setDefaultGateway(_gateway.Gateway);
					} else {
						setDefaultGateway(getDefaultGateway());
					}
				}
			}

			setTabsData(
				data.find(i => i?.Gateway?.Code === defaultGateway.Code) || data?.[0].Gateway?.Code
			);
		} catch (err) {
			console.error(err);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, pageContext]);

	const isMobile = useMediaQuery({ query: "(max-width: 780px)" });

	const [activeTab, setActiveTab] = useState(tabsData?.PromotionGroups[0].title);

	const handleTabChange = (e, tab) => {
		if (activeTab !== tab.title) {
			setActiveTab(tab.title);
		}
	};

	useEffect(() => {
		if (tabsData) {
			setActiveTab(tabsData?.PromotionGroups[0].title);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tabsData.PromotionGroups]);

	const availableGateways = pageContext.basePath
		? gateways.map((gateway, index) => ({
				url: addSEOSupportToURL(`${pageContext.basePath}/from-${gateway?.Name}`),
				linkText: gateway?.Name,
				id: index,
		  }))
		: gateways.map((gateway, index) => ({
				linkText: gateway?.Name,
				id: index,
				onClick: () => {
					setDefaultGateway(gateway);
					setTabsData(data.find(i => i?.Gateway?.Code === gateway.Code));
				},
		  }));

	const gatewayListUI = (
		<CollapsibleLinksList
			listHeading={RCL({ searchKey: "from" })}
			variant="classic"
			expanded={false}
			disabled={data.length === 1}
			linksGroup={[
				{
					entries: availableGateways,
				},
			]}
			customStyles={styles}
			labels={{
				allCategories: (
					<span className={styles.button}>
						{defaultGateway.Name}{" "}
						{data.length !== 1 && <Icon name="arrow-down" className="swg-text-sm" />}
					</span>
				),
			}}
		/>
	);

	return tabsData?.PromotionGroups ? (
		<>
			{availableGateways && !isMobile && (
				<div
					className={cx(
						styles.dropdownPan,
						tabsData?.PromotionGroups.length === 1 && styles.dropdownPanNoTabs
					)}>
					<div className={styles.dropdownWrapper}>{gatewayListUI}</div>
				</div>
			)}
			{tabsData?.PromotionGroups.length === 1 ? (
				<div
					className={cx({ [styles.singleTabHeader]: availableGateways })}
					key={defaultGateway.Code}>
					<RenderCards
						offers={tabsData?.PromotionGroups[0]?.Offers}
						locale={locale}
						renderLink={renderLink}
						isMobile={isMobile}
						gatewayListUI={gatewayListUI}
					/>
				</div>
			) : (
				<Tabs
					key={defaultGateway.Code}
					activeKey={activeTab}
					className={styles.tabs}
					variant={isMobile ? "merchMobile" : "merch"}>
					{tabsData?.PromotionGroups.map(tab => (
						<Tab
							key={`${tab.title}-${defaultGateway.Code}`}
							eventKey={tab.title}
							title={tab.title}
							onHandleCustomClick={e => {
								handleTabChange(e, tab);
							}}
							onHandleCustomKeys={e => {
								handleTabChange(e, tab);
							}}>
							<RenderCards
								offers={tab.Offers}
								locale={locale}
								renderLink={renderLink}
								isMobile={isMobile}
								gatewayListUI={gatewayListUI}
							/>
						</Tab>
					))}
				</Tabs>
			)}
		</>
	) : (
		""
	);
};

RenderCards.propTypes = {
	offers: PropTypes.arrayOf(
		PropTypes.shape({
			OfferType: PropTypes.string,
			Description: PropTypes.string,
			Offers: PropTypes.arrayOf(
				PropTypes.shape({
					AccommodationInfo: PropTypes.shape({
						AccommodationCode: PropTypes.string,
						AccommodationName: PropTypes.string,
						StarRating: PropTypes.number,
					}),
					CalendarLink: PropTypes.string,
					DeepLink: PropTypes.string,
					DepartureDate: PropTypes.string,
					Destination: PropTypes.shape({
						CountryName: PropTypes.string,
						Name: PropTypes.string,
						ProviderCode: PropTypes.string,
					}),
					Duration: PropTypes.number,
					Gateway: PropTypes.shape({
						Code: PropTypes.string,
						Name: PropTypes.string,
					}),
					MealPlan: PropTypes.string,
					OfferType: PropTypes.string,
					Price: PropTypes.number,
					RegPrice: PropTypes.number,
					SaveUpto: PropTypes.number,
					tax: PropTypes.string,
				})
			),
			title: PropTypes.string,
		}).isRequired
	).isRequired,
	locale: PropTypes.oneOf([LOCAL_FR, LOCAL_EN]).isRequired,
	renderLink: PropTypes.func.isRequired,
	isMobile: PropTypes.bool.isRequired,
	gatewayListUI: PropTypes.node.isRequired,
};
HotelCardTabs.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			Gateway: PropTypes.shape({
				Code: PropTypes.string,
				Name: PropTypes.string,
			}),
			PromotionGroups: PropTypes.arrayOf(
				PropTypes.shape({
					Description: PropTypes.string,
					Offers: PropTypes.arrayOf(
						PropTypes.shape({
							AccommodationInfo: PropTypes.shape({
								AccommodationCode: PropTypes.string,
								AccommodationName: PropTypes.string,
								StarRating: PropTypes.number,
							}),
							CalendarLink: PropTypes.string,
							DeepLink: PropTypes.string,
							DepartureDate: PropTypes.string,
							Destination: PropTypes.shape({
								CountryName: PropTypes.string,
								Name: PropTypes.string,
								ProviderCode: PropTypes.string,
							}),
							Duration: PropTypes.number,
							Gateway: PropTypes.shape({
								Code: PropTypes.string,
								Name: PropTypes.string,
							}),
							MealPlan: PropTypes.string,
							OfferType: PropTypes.string,
							Price: PropTypes.number,
							RegPrice: PropTypes.number,
							SaveUpto: PropTypes.number,
							tax: PropTypes.string,
						})
					),
					title: PropTypes.string,
				})
			),
		})
	).isRequired,
	locale: PropTypes.oneOf([LOCAL_FR, LOCAL_EN]),
	renderLink: PropTypes.func,
};
HotelCardTabs.defaultProps = {
	locale: LOCAL_EN,
	renderLink: undefined,
};

export default HotelCardTabs;
export { HotelCardTabs };
